import { Address } from './instores/Address';
import { BusinessConcepts } from './instores/BusinessConcepts';
import { ContactEmail } from './instores/ContactEmail';
import { Name } from './instores/Name';
import { SellingCountries } from './instores/SellingCountries';
import { StoreCategory } from './instores/StoreCategory';
import { StoreId } from './instores/StoreId';
import { SupportEmail } from './instores/SupportEmail';
import { SupportPhone } from './instores/SupportPhone';
export const InStores = {
    address: Address,
    business_concepts: BusinessConcepts,
    contact_email: ContactEmail,
    name: Name,
    selling_countries: SellingCountries,
    store_category: StoreCategory,
    store_id: StoreId,
    support_email: SupportEmail,
    support_phone: SupportPhone,
};
